<template>
  <div class="row">
    <div class="col-6 col-md-4 col-lg-6 col-xtra-large" v-for="(navigation, index) in navigations" :key="index">
      <router-link class="block block-rounded block-link-pop border-left border-4x" v-bind:class="navigation.aClass" v-bind:to="navigation.name">
        <div class="block-content block-content-full" v-bind:class="[navigation.colorClass]">
          <div class="font-size-sm font-w600 text-uppercase" v-bind:class="{'text-black': !navigation.status, 'text-white': navigation.status}">
            <i :class="navigation.iconClass"></i> {{ navigation.title }}
          </div>
          <div class="font-size-h2 font-w400" v-bind:class="{'text-dark': !navigation.status, 'text-white': navigation.status}">
            <strong>{{ Object.keys(library[navigation.key]).length }}</strong>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Navigation',
  props: ['active'],
  data() {
    return {
      navigations: [
        {
          'name': '/plantbatch',
          'title': 'Plant Batch',
          'url': '/plantbatches/active',
          'iconClass': [
            'fa', 'fa-object-group',
            (this.active === 'plantBatches' ? 'text-white' : 'text-muted')
          ],
          'aClass': ['border-light'],
          'colorClass': (this.active === 'plantBatches') ? 'bg-light' : '',
          'key': 'plantBatches',
          'status': (this.active === 'plantBatches')
        },
        {
          'name': '/vegetative',
          'title': 'Vegetative',
          'url': '/plants/vegetative',
          'iconClass': [
            'far', 'fa-lightbulb fa-rotate-180',
            (this.active === 'vegetativePlants' ? 'text-white' : 'text-muted')
          ],
          'aClass': ['border-info'],
          'colorClass': (this.active === 'vegetativePlants') ? 'bg-info' : '',
          'key': 'vegetativePlants',
          'status': (this.active === 'vegetativePlants')
        },
        {
          'name': '/flowering',
          'title': 'Flowering',
          'url': '/plants/flowering',
          'iconClass': [
            'fa', 'fa-cannabis',
            (this.active === 'floweringPlants' ? 'text-white' : 'text-muted')
          ],
          'aClass': ['border-success'],
          'colorClass': (this.active === 'floweringPlants') ? 'bg-success' : '',
          'key': 'floweringPlants',
          'status': (this.active === 'floweringPlants')
        },
        {
          'name': '/harvests',
          'title': 'Harvests',
          'url': '/harvests/active',
          'iconClass': [
            'fa', 'fa-cut',
            (this.active === 'harvests' ? 'text-white' : 'text-muted')
          ],
          'colorClass': (this.active === 'harvests') ? 'bg-primary' : '',
          'aClass': ['border-primary'],
          'key': 'harvests',
          'status': (this.active === 'harvests')
        },
        {
          'name': '/packages',
          'title': 'Packages',
          'url': '/packages/active',
          'iconClass': [
            'fa', 'fa-box-open',
            (this.active === 'packages' ? 'text-white' : 'text-muted')
          ],
          'colorClass': (this.active === 'packages') ? 'bg-danger' : '',
          'aClass': ['border-danger'],
          'key': 'packages',
          'status': (this.active === 'packages')
        },
      ]
    };
  },
  computed: {
    ...mapState({
      library: state => state.library
    })
  }
};
</script>

<style>
  .border-light {
    border-color: #9eb89f !important;
  }
  @media (min-width: 1200px) {
    .col-xtra-large {
      -ms-flex: 0 0 20%;
      flex: 0 0 20%;
      max-width: 20%;
    }
  }
</style>



// WEBPACK FOOTER //
// source/components/Navigation.vue